import React from 'react';
import Produtividade from '../../componentes/inicio/produtividade';

const Pendencias = () => {
    return (
        <Produtividade />
    )
}

export default Pendencias;